import React, { useCallback, useState } from 'react';
import { CheckOrgMembership } from './organisation/CheckOrgMembership';
import { ChooseOrganisation } from './organisation';
import { Switch, Route, useRouteMatch, useHistory } from 'react-router-dom';
import { Modal } from '../../components/Modal';
import { useBackController } from '../../hooks/useBackController';

export const SignUpModalLoginFlow = () => {
  const { url } = useRouteMatch();
  const history = useHistory();
  const closeModal = () => history.push('/');
  const [isLoading, setIsLoading] = useState(false);
  // we do similar things in the signup/SignUpOrganisation.js
  const {
    user,
    getBeginApplicationURL,
    myAccountURL,
    getApiRoute,
    chooseOrganisation,
  } = useBackController();
  const userOrg = user?.app_metadata.organisation;
  const handleChangeOrg = useCallback(
    async id => {
      if (!id) {
        return;
      }

      setIsLoading(true);

      await chooseOrganisation(id);

      history.push(`${url}/organisation/membership`);
      setIsLoading(false);
    },
    [chooseOrganisation, history, url]
  );

  return (
    <Modal
      isOpen={user?.email_verified}
      onEscape={closeModal}
      onOverlayClick={closeModal}
    >
      <Switch>
        {userOrg && (
          <Route path={`${url}/organisation/membership`}>
            <CheckOrgMembership
              selectOrgURL={`${url}/organisation`}
              isMembershipOrganisation={userOrg.ncvo_isMembershipOrganisation}
              orgName={userOrg.name}
              myAccountURL={myAccountURL}
              beginApplicationURL={getBeginApplicationURL(userOrg.name)}
            />
          </Route>
        )}
        <Route path={`${url}/organisation`}>
          <ChooseOrganisation
            isLoading={isLoading}
            onUpdateOrg={handleChangeOrg}
            organisationFetchURL={getApiRoute('organisation/search')}
            userHasOrg={!!userOrg}
          />
        </Route>
      </Switch>
    </Modal>
  );
};
